import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": true,
    title: $props.title,
    width: "550px",
    "model-value": $props.visible,
    "show-close": false,
    onClose: $setup.close,
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
      onClick: $setup.close
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("取 消", -1)]))]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.hanldeSubmit
    }, {
      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("提 交", -1)]))]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: _ctx.userInfo,
      rules: _ctx.rules,
      ref: "userForm",
      inline: true,
      "label-position": "right",
      "label-width": "80px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "账号",
        prop: "userId"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.userInfo.userId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.userInfo.userId = $event),
          size: "small",
          placeholder: "账号只能由英文、数字组成",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "姓名",
        prop: "empName"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.userInfo.empName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.userInfo.empName = $event),
          size: "small",
          placeholder: "请输入用户姓名",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "手机号码",
        prop: "mobile"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.userInfo.mobile,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.userInfo.mobile = $event),
          size: "small",
          placeholder: "请输入手机号码",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "邮箱",
        prop: "email"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.userInfo.email,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.userInfo.email = $event),
          size: "small",
          placeholder: "请输入邮箱",
          disabled: _ctx.disabled
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "性别",
        prop: "gender"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.userInfo.gender,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.userInfo.gender = $event),
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: "1",
            label: "女"
          }), _createVNode(_component_el_option, {
            value: "2",
            label: "男"
          }), _createVNode(_component_el_option, {
            value: "3",
            label: "未知"
          })]),
          _: 1
        }, 8, ["modelValue", "disabled"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "账号来源",
        prop: "userType"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.userInfo.userType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.userInfo.userType = $event),
          disabled: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: "2",
            label: "第三方"
          }), _createVNode(_component_el_option, {
            value: "0",
            label: "内部"
          }), _createVNode(_component_el_option, {
            value: "1",
            label: "外部"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "地市",
        prop: "areaCode"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.userInfo.areaCode,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.userInfo.areaCode = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.areaCode,
              label: item.areaName,
              value: item.areaCode
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]);
}